/**
 * @file 在线编辑器关闭提示工具
 * @description 统一维护入口关闭文案；后续恢复在线编辑器时，只需恢复各入口原跳转并移除路由兜底。
 */
import { ElMessage } from 'element-plus'

/** 在线编辑器关闭时统一提示文案。 */
export const EDITOR_DISABLED_MESSAGE = '在线编辑器暂时关闭，请直接上传稿件喵'

/** 统一提示在线编辑器当前不可用。 */
export function showEditorDisabledMessage(): void {
  ElMessage.warning(EDITOR_DISABLED_MESSAGE)
}
